import { render, staticRenderFns } from "./allSilderPc.vue?vue&type=template&id=ee584f60&scoped=true&"
import script from "./allSilderPc.vue?vue&type=script&lang=js&"
export * from "./allSilderPc.vue?vue&type=script&lang=js&"
import style0 from "./allSilderPc.vue?vue&type=style&index=0&id=ee584f60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee584f60",
  null
  
)

export default component.exports